module.exports = __webpack_public_path__ + "img/wuLong3.00cd8bba.png";